import { render, staticRenderFns } from "./MyPassword.vue?vue&type=template&id=4bcc907a&scoped=true"
import script from "./MyPassword.vue?vue&type=script&lang=js"
export * from "./MyPassword.vue?vue&type=script&lang=js"
import style0 from "./MyPassword.vue?vue&type=style&index=0&id=4bcc907a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc907a",
  null
  
)

export default component.exports